import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Home, LayoutDashboard, ArrowLeft } from "lucide-react";
import Background from "@/components/landing/Background";
import AppHeader from "@/components/nav/AppHeader";
import { useAuth } from "@/contexts/AuthContext";

const AUTO_REDIRECT_SECONDS = 8;

export default function NotFound() {
    const { user } = useAuth();
    const navigate = useNavigate();
    const target = user ? "/dashboard" : "/";
    const targetLabel = user ? "до кабінету" : "на головну";
    const [secondsLeft, setSecondsLeft] = useState(AUTO_REDIRECT_SECONDS);
    const [cancelled, setCancelled] = useState(false);

    useEffect(() => {
        if (cancelled) return;
        if (secondsLeft <= 0) {
            navigate(target, { replace: true });
            return;
        }
        const t = setTimeout(() => setSecondsLeft(s => s - 1), 1000);
        return () => clearTimeout(t);
    }, [secondsLeft, cancelled, navigate, target]);

    return (
        <div className="min-h-screen relative" data-testid="not-found">
            <Background />
            <div className="relative z-10 min-h-screen flex flex-col">
                <AppHeader mode="public" />
                <main className="flex-1 flex items-center justify-center px-6">
                    <div className="text-center max-w-lg">
                        <h1 className="font-display font-extrabold text-primary-c" style={{ fontSize: "clamp(96px, 18vw, 220px)", letterSpacing: "-0.05em", lineHeight: 0.9 }}>404</h1>
                        <p className="mt-4 font-display font-bold text-text-primary text-2xl">Сторінку не знайдено</p>
                        <p className="mt-3 text-secondary-c">
                            Можливо, посилання застаріле або ви вписали адресу з помилкою. Без паніки — ми вас доведемо туди, куди треба.
                        </p>
                        <div className="mt-8 flex items-center justify-center gap-3 flex-wrap" data-testid="nf-actions">
                            <Link to={target} className="btn-primary inline-flex items-center gap-2" data-testid="nf-primary">
                                {user ? <LayoutDashboard size={16} /> : <Home size={16} />}
                                Перейти {targetLabel} →
                            </Link>
                            <button
                                onClick={() => navigate(-1)}
                                className="btn-ghost inline-flex items-center gap-2"
                                data-testid="nf-back-btn"
                            >
                                <ArrowLeft size={14} /> Назад
                            </button>
                        </div>
                        {!cancelled && (
                            <p className="mt-6 text-xs text-faint-c" data-testid="nf-redirect-hint">
                                Автоматичне перенаправлення через {secondsLeft} с ·{" "}
                                <button
                                    onClick={() => setCancelled(true)}
                                    className="text-primary-c hover:underline"
                                    data-testid="nf-cancel-redirect"
                                >скасувати</button>
                            </p>
                        )}
                    </div>
                </main>
            </div>
        </div>
    );
}
